import vuexStore from "@/store"

// Who a request would be sent as: the app plus the member's email and token.
export function sessionIdentity(): string {
  const hasSession = vuexStore.getters["auth/hasSession"]

  return [
    vuexStore.getters.app?.slug,
    hasSession ? vuexStore.getters["auth/currentUser"].email : "anonymous",
    hasSession ? vuexStore.getters["auth/authenticationToken"] : ""
  ].join("|")
}
